<template>
	<div class="page">
		<div class="page__top-bar">
			<div class="page__title"><svg-icon @click="toggleMobileMenu" class="icon" icon="menu" />{{ title }}</div>
			<page-tabs-view :items="pages" @itemClick="navItemClick" />
			<div class="page__tools">
				<slot name="tools" />
			</div>
		</div>
		<router-view ref="page" class="" />
	</div>
</template>

<script>
	import { bus } from './../../bus';

	export default {
		props: ['title', 'pages'],
		methods: {
			navItemClick: function (name) {
				this.$router.push({
					name: name
				});
			},
			toggleMobileMenu() {
				bus.$emit('mobile-menu-toggle');
			}
		}
	}
</script>

<style lang="scss">
	.page {
		&__title {
			display: block;
			float: left;
		}
	}

	@media only screen and (max-width: 600px) {
		.page__tabs {
			display: none;
		}
	}
</style>